module.exports = __webpack_public_path__ + "img/list.2c4d5468.png";